import { Component, OnInit } from '@angular/core';
import { NewsService, INews } from '../../../shared/services/news.service';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
  selector: 'app-news',
  templateUrl: './news.component.html',
  styleUrls: ['./news.component.scss']
})
export class NewsComponent implements OnInit {

  newsName = '';
  news: INews;
  sectionTitle: string;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private newsService: NewsService
  ) { }

  ngOnInit() {
    this.sectionTitle = 'News & Media';

    // window.scrollTo(0, 0);

    this.newsName = this.route.snapshot.paramMap.get('newsName');
    this.newsService.get(this.newsName).then(result => {
      this.news = result;
      if (!this.news) {
        //  this.router.navigate(['/page-not-found']);
        // console.log(this.newsName);
        // console.log(this.news);
      }
    });
  }

}
